// @flow
import React from 'react';
import Group from 'sail/Group';
import {ClientSetting} from './components/ClientSetting';
import {ServerSetting} from './components/ServerSetting';

export const WEB_ONLY_SETTINGS = {
  platforms: ['web'],
  clients: {web: ['html', 'react']},
  servers: ['ruby', 'node', 'php', 'python', 'go', 'dotnet', 'java'],
};

export const WebOnlySettings = () => {
  return (
    <Group direction="horizontal" alignItems="center" spacing={24}>
      <ClientSetting clients={WEB_ONLY_SETTINGS.clients} />
      <ServerSetting servers={WEB_ONLY_SETTINGS.servers} />
    </Group>
  );
};
